import React from 'react';
import { Tag } from 'antd';

import { RecommendationsControlsIcons } from '../components/RecommendationsControlsIcons';
import { getDeclension } from '../../../../../utils/common/getDeclension';
import { CommunityProps } from '../service/recommendations.interface';

const renderChatTags = (item: CommunityProps[]) => {
    return item.map(chat => <Tag key={chat.id}>{chat.title}</Tag>);
};

const renderIntervalDay = (period: number) => {
    return (
        <>
            {period} {getDeclension(period, 'день', 'дня', 'дней')}
        </>
    );
};

export const getColumns = () => {
    return [
        {
            title: 'Сообщества',
            dataIndex: 'communities',
            key: 'communities',
            render: (communities: CommunityProps[]) =>
                renderChatTags(communities),
            ellipsis: true,
            width: '80%',
        },
        {
            title: 'Период',
            dataIndex: 'interval_hours',
            key: 'interval_hours',
            render: (interval_hours: number) =>
                renderIntervalDay(interval_hours),
        },
        {
            title: '',
            dataIndex: 'type',
            key: 'type',
            render: (_, record) => <RecommendationsControlsIcons {...record} />,
        },
    ];
};
